import { Hub } from '@/models/registry';
import type { BaseStore } from '@/models/stores/base';
import type { Hub as HubType } from '@/models/types';
import { makeAutoObservable } from 'mobx';
import type { DeltaPacketRecord } from '../hydrate';
import { hydrateFromWorker } from '../hydrate-worker-utils';

class HubStore implements BaseStore<Hub, HubType> {
  store: Map<string, Hub> = new Map();

  applyDeltas({
    deltas,
    hydrateIndexedDB,
  }: {
    deltas: DeltaPacketRecord<HubType>[];
    hydrateIndexedDB?: boolean;
  }): void {
    console.log('hubs applyDeltas not implemented', deltas, hydrateIndexedDB);
    this.applyDelta({ delta: deltas[0], hydrateIndexedDB });
  }

  applyDelta({
    delta,
    hydrateIndexedDB,
  }: {
    delta: DeltaPacketRecord<HubType>;
    hydrateIndexedDB?: boolean;
  }): void {
    console.log('hubs applyDelta not implemented', delta, hydrateIndexedDB);
  }

  constructor() {
    makeAutoObservable(this);
  }

  getById(id: string): Hub | undefined {
    return this.store.get(id);
  }

  getByPathIdentifier(pathIdentifier: string): Hub | undefined {
    return this.all.find((hub) => hub.path_identifier === pathIdentifier);
  }

  add(input: HubType) {
    const hub = new Hub(input);
    this.store.set(hub.id, hub);
  }

  // Computed getters - automatically update when store changes
  get all() {
    return Array.from(this.store.values());
  }

  get allHubPathIds() {
    return Array.from(this.store.values()).map((hub) => hub.path_identifier);
  }

  upsert(hub: HubType) {
    const existingHub = this.store.get(hub.id);
    if (existingHub) {
      // todo: add replace when more editing features are added for hubs
      return;
    } else {
      this.add(hub);
    }
  }

  async hydrateLocal(): Promise<void> {
    // DEV NOTE: If we define `tableName` and `entity` using `hydrationConfigs`
    // it will cause a race condition where hubStore is not defined yet.
    // Thus we hardcode the values here.
    await hydrateFromWorker({
      tableName: 'hubs',
      entity: 'hubs',
      modelStore: hubStore,
    });
  }
}

export const hubStore = new HubStore();
